import { AdUtils } from "./ads";
import { apiRequest } from "./request";
import utils from "./utils";
import * as md5 from "js-md5";

// 类型定义
interface ErrorItem {
  error: Error;
  errorInfo: any;
  key: string;
}

const errorQueue: ErrorItem[] = [];
const errorLoggedKey: string[] = [];
const errorReportVersion: number = 36;

export function myErrorReport(error: Error, errorInfo: any): void {
  const key = md5.md5(error.stack || "");
  if (errorLoggedKey.includes(key) || errorQueue.find(x => x.key === key))
    return;
  errorQueue.push({ error, errorInfo, key });
}

export async function startErrorReportLoop(): Promise<void> {
  while (true) {
    await utils.sleep(10000);
    try {
      if (errorQueue.length) {
        await logInTimer();
      }
    } catch {
      // TODO: 处理错误
    }
  }
}

async function logInTimer(): Promise<void> {
  try {
    console.log("errorQueue", errorQueue);
    const { error, key } = errorQueue[0];
    await logErrorToMyService(error);
    errorLoggedKey.push(key);
    errorQueue.shift();
  } catch {
    // TODO: 处理错误
  }
}

async function logErrorToMyService(error: Error): Promise<void> {
  try {
    const content = `${error.toString()}\nstack:${error.stack}`;
    await apiRequest(
      "/api/home/reportError",
      {
        url: window.location.href,
        content,
        version: errorReportVersion + "",
      },
      { alert: false, method: "POST" }
    );
    AdUtils.onError(content);
  } catch {
    // TODO: 处理错误
  }
}
